import React from 'react'
import { Link } from 'react-router-dom'
import "./footercomponent.css"

const FooterComponent = () => {
  return (
    <footer className=" text-white py-4 footer">
    <div className="container-fluid">
      <div className="d-flex justify-content-center text-center">
        <div style={{ width: "80%" }}>
          <div
            className="separator bg-white my-3"
            style={{ height: 2 }}
          ></div>
          <div className="footer-navigation">
            <a href="https://www.healproject.org/Default.aspx" target="_blank" rel="noopener noreferrer" className="footer-navlinks">
               HEAL Project
            </a>
            <Link to="/privacy-policy" className="footer-navlinks">
               Privacy Policy
            </Link>
            <Link to="/contact-us" className="footer-navlinks">
               Contact Us
            </Link>
            <a href="https://hospicevolunteerassociation.ning.com/" target="_blank" rel="noopener noreferrer" className="footer-navlinks">
               HCF
            </a>
          </div>
        </div>
      </div>

      <div className="d-flex justify-content-center">
        <div style={{ width: "80%" }}>
          <div className="row">
            <div className="mt-3 footer-text col-12 col-md-6 text-left">
              In Collaboration with Hospice Volunteer Association
            </div>
            <div className="mt-3 footer-text col-12 col-md-6 text-right">
              &copy; copyright 2005-{new Date().getFullYear()} HEAL Project. All rights reserved
            </div>
          </div>
        </div>
      </div>
    </div>
  </footer>
  )
}

export default FooterComponent
